export default __webpack_public_path__ + "/dist/images/dummy-image-landscape.bb3ba90abd03d1575c9c38e15c6f0777.jpg";